/**
 * Sorts and removes duplicates from an array of rental/timeslot courts.
 * Assumes that courts are always formatted as `Surface CourtName` and there is only 1 surface type in the array.
 *
 * @example
 * ```
 * sortCourts(['Court 10', 'Court 2', 'Court 3', 'Court 2']) // ['Court 2', 'Court 3', 'Court 10']
 * sortCourts(['Space Outside', 'Space Inside']) // ['Space Inside', 'Space Outside']
 * ```
 */
export const sortCourts = (courts) => {
    const uniqueCourts = [...new Set(courts)];
    return uniqueCourts.sort((a, b) => {
        const aCourtName = a.split(' ')[1];
        const bCourtName = b.split(' ')[1];
        return aCourtName.localeCompare(bCourtName, undefined, { numeric: true, sensitivity: 'base' });
    });
};
